let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("i8jRD")).then(() => parcelRequire('k1d4Y'));